import { render, staticRenderFns } from "./TasksProvider.vue?vue&type=template&id=51a58f70&"
import script from "./TasksProvider.vue?vue&type=script&lang=js&"
export * from "./TasksProvider.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports